import React, {memo} from 'react';
import styled from 'styled-components';

import {AttachmentModel} from '../../../../../../libs/shared/core/src/models/api/attachmentModel';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';

/*
 * Props.
 */

interface MessageViewerAttachmentsIconProps {
  attachments: ReadonlyArray<AttachmentModel>;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  grid-area: attachments;
  margin: 0 6px 0 7px;
`;

/*
 * Components.
 */

export const MessageViewerAttachmentsIcon = memo<MessageViewerAttachmentsIconProps>((props) => {
  const visibleAttachments = props.attachments.filter((a) => !a.isInline);
  const visibleAttachmentCount = visibleAttachments.length;
  if (visibleAttachmentCount === 0) {
    return null;
  }

  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledWrapperDiv>
          <Icon name="attachment" color={theme.greys.shade60} />
        </StyledWrapperDiv>
      )}
    </UserThemeConsumer>
  );
});
